import API from 'services/api';

export const getLanguages = () => API.get('/api/languages/all');
